import Breadcrumb from "../../Component/Breadcrumb";

function BusFacility() {
  return (
    <>
      <Breadcrumb>Students / Bus Facility</Breadcrumb>
      <div className="innersec admission_sec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Bus Facility</h1>
          </div>
          <ol>
            <li>
              The school provides bus service for the commutation of students.
            </li>
            <li>
              The preference is given to the students from primary and junior
              classes. The conveyance facility is available for girls and boys.
            </li>
            <li>
              Conveyance fees will be charged for all twelve months; it is
              non-refundable.
            </li>
            <li>Bus fee is taken in 2 instalments.</li>
            <li>
              Bus will run on prescribed routes and fixed days only. Conveyance
              fee is to be remitted in the Bank (Indian Overseas Bank,
              Barhalganj Branch).
            </li>
            <li>
              No admission for the same will be provided or cancelled during the
              academic session.
            </li>
            <li>
              Anyone who wants to discontinue the bus conveyance will have to
              pay the charge for the whole year and is requested to submit an
              application in the school office.
            </li>
            <li>
              During the board examinations and other examinations conducted
              separately for any particular class, the school bus shall not run
              to carry those students to the school.
            </li>
            <li>
              Admission in the school does not guarantee admission in the bus.
            </li>
            <li>
              Admission in the bus will be given according to the availability
              of the seats.
            </li>
            <li>
              Conveyance facility shall not be granted for less than a session
              (12 months).
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}
export default BusFacility;
